import { ComponentClass } from 'react';

import InputBase from './Base';
import { CoreFormElementPassword } from '../../../components/';

/**
 * Password Input Controller
 * @export
 * @class PasswordInputController
 * @extends {InputBase}
 */
export default class PasswordInputController extends InputBase {
  /**
   * Controlled Element
   * @override
   * @static
   * @memberof PasswordInputController
   */
  public static ControlledElement: ComponentClass<any> = CoreFormElementPassword;
}
